
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { doc, getDoc, updateDoc, addDoc, collection, serverTimestamp } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyAZI8_sVE4UpdIl0ZehIQB0u1ZzydRtGTY",
  authDomain: "switzerland-bank.firebaseapp.com",
  projectId: "switzerland-bank",
  storageBucket: "switzerland-bank.firebasestorage.app",
  messagingSenderId: "228937537609",
  appId: "1:228937537609:web:58baa676d6b7f7f1b60798"
};

      const app = initializeApp(firebaseConfig);
      const auth = getAuth(app);
      const firestore = getFirestore(app);
      const storage = getStorage(app);
      
      export { auth, firestore, storage };